/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrateColor } from './CrateColor';
import {
    CrateColorFromJSON,
    CrateColorFromJSONTyped,
    CrateColorToJSON,
    CrateColorToJSONTyped,
} from './CrateColor';
import type { EVMChain } from './EVMChain';
import {
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    EVMChainToJSONTyped,
} from './EVMChain';

/**
 * Shared by create and update. contractAddress and evmChain are NOT required at the schema level because a badge has neither — both handlers require them only when isBadge is false. Declaring them required here asserted the opposite of what the handlers enforce, which is what left badge trackers uneditable.
 * @export
 * @interface AddNftTrackerBody
 */
export interface AddNftTrackerBody {
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    grouping: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    contractAddress?: string;
    /**
     * 
     * @type {EVMChain}
     * @memberof AddNftTrackerBody
     */
    evmChain?: EVMChain;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    openSea?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddNftTrackerBody
     */
    isIneligibleForLeaderboards?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AddNftTrackerBody
     */
    maxLimitMint?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddNftTrackerBody
     */
    useThirdwebEngine?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    relayerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    forwarderAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddNftTrackerBody
     */
    mintVirtually?: boolean;
    /**
     * This tracker is a BADGE — an on-account collectible that never touches a chain. A badge implies mintVirtually, and the chain fields (contractAddress, evmChain, openSea, maxLimitMint) are not required for one.
     * @type {boolean}
     * @memberof AddNftTrackerBody
     */
    isBadge?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    mintImage?: string;
    /**
     * 
     * @type {CrateColor}
     * @memberof AddNftTrackerBody
     */
    crateColor?: CrateColor;
}



/**
 * Check if a given object implements the AddNftTrackerBody interface.
 */
export function instanceOfAddNftTrackerBody(value: object): value is AddNftTrackerBody {
    if (!('grouping' in value) || value['grouping'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AddNftTrackerBodyFromJSON(json: any): AddNftTrackerBody {
    return AddNftTrackerBodyFromJSONTyped(json, false);
}

export function AddNftTrackerBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddNftTrackerBody {
    if (json == null) {
        return json;
    }
    return {
        
        'grouping': json['grouping'],
        'contractAddress': json['contractAddress'] == null ? undefined : json['contractAddress'],
        'evmChain': json['evmChain'] == null ? undefined : EVMChainFromJSON(json['evmChain']),
        'name': json['name'],
        'openSea': json['openSea'] == null ? undefined : json['openSea'],
        'isIneligibleForLeaderboards': json['isIneligibleForLeaderboards'] == null ? undefined : json['isIneligibleForLeaderboards'],
        'maxLimitMint': json['maxLimitMint'] == null ? undefined : json['maxLimitMint'],
        'useThirdwebEngine': json['useThirdwebEngine'] == null ? undefined : json['useThirdwebEngine'],
        'relayerUrl': json['relayerUrl'] == null ? undefined : json['relayerUrl'],
        'forwarderAddress': json['forwarderAddress'] == null ? undefined : json['forwarderAddress'],
        'mintVirtually': json['mintVirtually'] == null ? undefined : json['mintVirtually'],
        'isBadge': json['isBadge'] == null ? undefined : json['isBadge'],
        'mintImage': json['mintImage'] == null ? undefined : json['mintImage'],
        'crateColor': json['crateColor'] == null ? undefined : CrateColorFromJSON(json['crateColor']),
    };
}

export function AddNftTrackerBodyToJSON(json: any): AddNftTrackerBody {
    return AddNftTrackerBodyToJSONTyped(json, false);
}

export function AddNftTrackerBodyToJSONTyped(value?: AddNftTrackerBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grouping': value['grouping'],
        'contractAddress': value['contractAddress'],
        'evmChain': EVMChainToJSON(value['evmChain']),
        'name': value['name'],
        'openSea': value['openSea'],
        'isIneligibleForLeaderboards': value['isIneligibleForLeaderboards'],
        'maxLimitMint': value['maxLimitMint'],
        'useThirdwebEngine': value['useThirdwebEngine'],
        'relayerUrl': value['relayerUrl'],
        'forwarderAddress': value['forwarderAddress'],
        'mintVirtually': value['mintVirtually'],
        'isBadge': value['isBadge'],
        'mintImage': value['mintImage'],
        'crateColor': CrateColorToJSON(value['crateColor']),
    };
}

